var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "relative"
  }, [_vm.listItems[0] ? _c('div', {
    class: 'flex items-center justify-center rounded-full bg-white text-indigo-600 border border-indigo-600 text-sm absolute uppercase ' + _vm.size + ' ' + (_vm.listItems.length == 2 ? '-left-6' : _vm.listItems.length == 3 ? '-left-12' : _vm.listItems.length > 3 ? '-left-18' : ''),
    domProps: {
      "innerHTML": _vm._s(_vm.initialsOrImage(0))
    }
  }) : _vm._e(), _vm._v(" "), _vm.listItems[1] ? _c('div', {
    class: 'flex items-center justify-center rounded-full bg-white text-indigo-600 border border-indigo-600 text-sm absolute uppercase ' + _vm.size + ' ' + (_vm.listItems.length == 3 ? '-left-6' : _vm.listItems.length > 3 ? '-left-12' : ''),
    domProps: {
      "innerHTML": _vm._s(_vm.initialsOrImage(1))
    }
  }) : _vm._e(), _vm._v(" "), _vm.listItems[2] ? _c('div', {
    class: 'flex items-center justify-center rounded-full bg-white text-indigo-600 border border-indigo-600 text-sm absolute uppercase ' + _vm.size + ' ' + (_vm.listItems.length > 3 ? '-left-6' : ''),
    domProps: {
      "innerHTML": _vm._s(_vm.initialsOrImage(2))
    }
  }) : _vm._e(), _vm._v(" "), _vm.listItems.length > 3 ? _c('div', {
    class: _vm.size + ' flex items-center justify-center rounded-full bg-white text-indigo-600 border border-indigo-600 text-sm absolute'
  }, [_vm._v("\n    +" + _vm._s(_vm.listItems.length - 3) + "\n  ")]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }